import React, { useState, useEffect } from 'react';
import useDarkMode from '../../../../hooks/useDarkMode';
import useThemeColor from "../../../../hooks/useThemeColor";
import { useSelector } from 'react-redux';

const ChoiceButton = ({ title, description, defaultButton, isActive = false, onClick }) => {
  // Get app settings from Redux
  const appSettings = useSelector((state) => state.appSettings);
  const { appTheme } = appSettings;
  
  // Check if dark mode is enabled
  const isDarkMode = useDarkMode();

  // Get theme color from centralized hook
  const themeColor = useThemeColor();

  
  return (
    <div
      className={`rounded-4 p-3 m-0 position-relative`}
      style={{
        width: '100%',
        maxWidth: '230px',
        minHeight: '88px',
        cursor: 'pointer',
        backgroundColor: isActive 
          ? 'transparent' 
          : isDarkMode 
            ? '#404040' 
            : '#F5F5F5',
        border: '2px solid ',
        borderColor: isActive 
          ? themeColor
          : defaultButton 
            ? (isDarkMode ? '#666' : '#d9d9d9') 
            : 'transparent',
        transition: 'all 0.2s ease',
        color: isDarkMode ? '#ffffff' : '#000000',
      }}
      onClick={onClick}
    >
      {defaultButton && (
        <span
          className="position-absolute badge text-white"
          style={{
            top: 0,
            right: '8%',
            backgroundColor: themeColor,
            padding: '6px 12px',
            fontSize: '9px',
            borderRadius: '0 0 1rem 1rem'
          }}
        >
          Default
        </span>
      )}
      <h2 
        className="mb-2" 
        style={{ 
          fontSize: '18px', 
          fontWeight: 400,
          color: isDarkMode ? '#ffffff' : '#000000',
        }}
      >
        {title}
      </h2>
      <p 
        className="text-secondary" 
        style={{ 
          fontSize: '12px', 
          fontWeight: 400,
          color: isDarkMode ? '#adb5bd' : '#6c757d',
        }}
      >
        {description}
      </p>
    </div>
  );
};

export default ChoiceButton;


const buttonGridList = [
  { id: 'Food', title: 'Food', description: 'Best for Restaurants', default: true },
  { id: 'Beverage', title: 'Beverage', description: 'Best for Bars', default: false },
  { id: 'PhysicalGood', title: 'Physical good', description: 'Best for Retails', default: false },
  { id: 'FoodAndBeverage', title: 'Food and Beverage', description: 'Best for Restaurants', default: false }
];

export const ChoiceButtonGrid = ({ buttons, activeButton, handleClick }) => {
  // Default button grid list if no buttons are provided
  const buttonsList = buttons || buttonGridList;
  return (
    <div
      style={{
        padding: "8px 4px 4px",
        display: "grid",
        gridTemplateColumns: "repeat(2, minmax(220px, 220px))",
        gap: "12px",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display: "contents",
        }}
      >
        {buttonsList.map((button) => (
          <div key={button.id}>
            <ChoiceButton
              title={button.title}
              description={button.description}
              isActive={activeButton === button.title}
              onClick={() => handleClick(button.title)}
              defaultButton={button.default}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

